/* 사용자 페이지 관련 시작 */
export const WithdrawalAdminPath = [
  { label: "홈", href: "/admin" },
  { label: "회원", href: "/admin/users" },
  { label: "탈퇴" },
];
export const WithdrawalAdminTitle =
  WithdrawalAdminPath[WithdrawalAdminPath.length - 1].label;
/* 사용자 페이지 관련 끝 */
